// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-section .info-section {
  margin-top: -5px;
}

.homepage-link {
  text-decoration: underline !important;
}

.contact-section .img-section,
.ticket-section .img-section {
  display: block;
  float: left;
  height: 50px;
  margin-right: 25px;
  width: 45px;
}

.contact-section .info-section,
.ticket-section .info-section {
  float: left;
  margin-bottom: 0;
  max-width: 220px;
  display: block;
  font-size: 15px;
}

@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.phone-container {
  padding: 0 0px 0 0px;
}

.chat-container {
  padding: 0 15px 0 0;
}

.contact-img-section {
  display: block;
  float: left;
  height: 74px;
  margin-right: 20px;
  width: 74px;
}
.contact-img-section .icon-custm-style {
  color: #333333 !important;
  font-size: 74px;
}
.contact-img-section .icon-bubble-messagingL,
.contact-img-section .icon-bubble-messagingL::before {
  height: 83px !important;
}

h1 {
  margin-bottom: 70px !important;
}

.info-section {
  float: left;
  margin-bottom: 40px;
}

h2 {
  margin-bottom: 30px;
}

.chat-section {
  margin-bottom: 30px;
}

@media (max-width: 1024px) {
  .mobile {
    padding-top: 50px;
  }
  .info-section {
    max-width: 165px;
    margin-bottom: 0;
  }
  .icon-custm-style {
    font-size: 80px;
  }
  .chat-btn {
    margin: 0 0 30px;
    width: 100%;
  }
  .section-seperator {
    margin: 10px 0 30px;
  }
  .chat-section {
    margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/contact/contact.component.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AACF;;AACA;;EAEE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAEF;;ACAI;EA4BA;IACE,YClDE;EF0BN;ECuBE;IACE,aClDE;EF6BN;ECoBE;IACE,UClDE;EFgCN;ECiBE;IACE,aClDE;EFmCN;ECcE;IACE,aClDE;EFsCN;ECWE;IACE,UClDE;EFyCN;ECQE;IACE,aClDE;EF4CN;ECKE;IACE,aClDE;EF+CN;ECEE;IACE,UClDE;EFkDN;ECDE;IACE,aClDE;EFqDN;ECJE;IACE,aClDE;EFwDN;ECPE;IACE,WClDE;EF2DN;ECLE;IACE,kBCvDE;EF8DN;ECRE;IACE,mBCvDE;EFiEN;ECXE;IACE,gBCvDE;EFoEN;ECdE;IACE,mBCvDE;EFuEN;ECjBE;IACE,mBCvDE;EF0EN;ECpBE;IACE,gBCvDE;EF6EN;ECvBE;IACE,mBCvDE;EFgFN;EC1BE;IACE,mBCvDE;EFmFN;EC7BE;IACE,gBCvDE;EFsFN;EChCE;IACE,mBCvDE;EFyFN;ECnCE;IACE,mBCvDE;EF4FN;ECtCE;IACE,iBCvDE;EF+FN;AACF;ACvEI;EAoCA;IACE,YC9DE;EFoGN;ECvCE;IACE,aC9DE;EFuGN;EC1CE;IACE,UC9DE;EF0GN;EC7CE;IACE,aC9DE;EF6GN;EChDE;IACE,aC9DE;EFgHN;ECnDE;IACE,UC9DE;EFmHN;ECtDE;IACE,aC9DE;EFsHN;ECzDE;IACE,aC9DE;EFyHN;EC5DE;IACE,UC9DE;EF4HN;EC/DE;IACE,aC9DE;EF+HN;EClEE;IACE,aC9DE;EFkIN;ECrEE;IACE,WC9DE;EFqIN;ECnEE;IACE,kBCnEE;EFwIN;ECtEE;IACE,mBCnEE;EF2IN;ECzEE;IACE,gBCnEE;EF8IN;EC5EE;IACE,mBCnEE;EFiJN;EC/EE;IACE,mBCnEE;EFoJN;EClFE;IACE,gBCnEE;EFuJN;ECrFE;IACE,mBCnEE;EF0JN;ECxFE;IACE,mBCnEE;EF6JN;EC3FE;IACE,gBCnEE;EFgKN;EC9FE;IACE,mBCnEE;EFmKN;ECjGE;IACE,mBCnEE;EFsKN;ECpGE;IACE,iBCnEE;EFyKN;AACF;AAlJA;EACE,oBAAA;AAoJF;;AAlJA;EACE,mBAAA;AAqJF;;AAnJA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAsJF;AApJE;EACE,yBAAA;EACA,eAAA;AAsJJ;AApJA;;EAEI,uBAAA;AAsJJ;;AAnJA;EACE,8BAAA;AAsJF;;AApJA;EACE,WAAA;EACA,mBAAA;AAuJF;;AApJA;EACE,mBAAA;AAuJF;;AApJA;EACE,mBAAA;AAuJF;;AC7LI;ED0CF;IACE,iBAAA;EAuJF;EArJA;IACE,gBAAA;IACA,gBAAA;EAuJF;EApJA;IACE,eAAA;EAsJF;EAnJA;IACE,gBAAA;IACA,WAAA;EAqJF;EAlJA;IACE,mBAAA;EAoJF;EAjJA;IACE,mBAAA;EAmJF;AACF","sourcesContent":[".ticket-section .info-section {\n  margin-top: -5px;\n}\n\n.homepage-link {\n  text-decoration: underline !important;\n}\n\n.contact-section .img-section,\n.ticket-section .img-section {\n  display: block;\n  float: left;\n  height: 50px;\n  margin-right: 25px;\n  width: 45px;\n}\n.contact-section .info-section,\n.ticket-section .info-section {\n  float: left;\n  margin-bottom: 0;\n  max-width: 220px;\n  display: block;\n  font-size: 15px\n}\n\n@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.phone-container {\n  padding: 0 0px 0 0px;\n}\n.chat-container {\n  padding:0 15px 0 0;\n}\n.contact-img-section {\n  display: block;\n  float: left;\n  height: 74px;\n  margin-right: 20px;\n  width: 74px;\n\n  .icon-custm-style {\n    color: color(inverse, dark) !important;\n    font-size: 74px;\n}\n.icon-bubble-messagingL,\n  .icon-bubble-messagingL::before {\n    height: 83px !important;\n  }\n}\nh1 {\n  margin-bottom: 70px !important;\n}\n.info-section {\n  float: left;\n  margin-bottom: 40px;\n}\n\nh2 {\n  margin-bottom: 30px;\n}\n\n.chat-section {\n  margin-bottom: 30px;\n}\n\n@include respond-to (small) {\n  .mobile{\n    padding-top: 50px;\n  }\n  .info-section {\n    max-width: 165px;\n    margin-bottom: 0;\n  }\n\n  .icon-custm-style {\n    font-size: 80px;\n  }\n\n  .chat-btn {\n    margin: 0 0 30px;\n    width: 100%;\n  }\n\n  .section-seperator {\n    margin: 10px 0 30px;\n  }\n\n  .chat-section{\n    margin-bottom: 10px;\n  }\n}\n","@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
